import {
  BorrowerOwnsPrimaryResidence,
  CoborrowerOwnsPrimaryResidence
} from '../../cards/owns-primary-residence';
import {
  BorrowerResidenceSoldPrior,
  CoborrowerResidenceSoldPrior
} from '../../cards/residence-sold-prior';
import { Branch, Card } from '../../components/deck';

const ownsPrimaryResidence = {
  borrower: BorrowerOwnsPrimaryResidence,
  coborrower: CoborrowerOwnsPrimaryResidence
};

const residenceSoldPrior = {
  borrower: BorrowerResidenceSoldPrior,
  coborrower: CoborrowerResidenceSoldPrior
};

export default (borrowerKey, continuation) =>
  Branch(
    {
      Refi: Card(ownsPrimaryResidence[borrowerKey]),
      Purchase: Card(
        ownsPrimaryResidence[borrowerKey],
        Branch(
          {
            owns: Card(residenceSoldPrior[borrowerKey])
          },
          ({ model }) => (model.getIn([borrowerKey, 'ownsPrimaryResidence']) ? 'owns' : null)
        )
      )
    },
    ({ model }) => {
      if (model.getIn([borrowerKey, 'firstTimeBuyer'])) {
        return null;
      }
      if (['RefiQualify', 'RefiFull'].includes(model.getIn(['loan', 'scenario']))) {
        return model.getIn(['loan', 'occupancy']) === 'PrimaryResidence' &&
          borrowerKey === 'borrower'
          ? null
          : 'Refi';
      }
      return 'Purchase';
    },
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/ownership.js